export const documentPreviewValues = {
  companyName: "Smart IMS",
  contactName: "Ronaldo",
  date: "01’Oct 2023",
  stateName: "Telangana",
};
